import React from 'react';

declare const __APP_VERSION__: string;

function BuildBadge() {
    const appEnv = import.meta.env.VITE_APP_ENV;

    if (!appEnv || appEnv === 'prod') {
        return null;
    }

    const buildDate = import.meta.env.VITE_BUILD_DATE;
    const label = appEnv === 'nightly' ? `Nightly build ${__APP_VERSION__} ${buildDate}` : `${appEnv} - ${__APP_VERSION__} - ${buildDate}`;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 8,
                right: 8,
                color: 'red',
                fontSize: '18px',
                fontWeight: 'bold',
                zIndex: 9999,
                pointerEvents: 'none',
                userSelect: 'none'
            }}
        >
            {label}
        </div>
    );
}

export default BuildBadge;
